<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'AGT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                                <i @click="setSortTable('AG')" :class="setSortLogo('AG')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PKVC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GPS']['PKVC']}}
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CKMMW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CKMMW']}}
                                                <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'NND'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['NND']}}
                                                <i @click="setSortTable('TAND')" :class="setSortLogo('TAND')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TND'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TND']}}
                                                <i @click="setSortTable('TAD')" :class="setSortLogo('TAD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['AD']}}
                                                <i @click="setSortTable('AD')" :class="setSortLogo('AD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TANW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TANW']}}
                                                <i @click="setSortTable('TANW')" :class="setSortLogo('TANW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TAW'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TAW']}}
                                                <i @click="setSortTable('TAW')" :class="setSortLogo('TAW')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'NP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['NP']}}
                                                <i @click="setSortTable('NP')" :class="setSortLogo('NP')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TP']}}
                                                <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'DLS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['DLS']}}
                                                <i @click="setSortTable('DLS')" :class="setSortLogo('DLS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['AR']}}
                                                <i @click="setSortTable('ARA')" :class="setSortLogo('ARA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'A'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['A']}}
                                                <i @click="setSortTable('AA')" :class="setSortLogo('AA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TNMT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['TNMT']}}
                                                <i @click="setSortTable('TNMT')" :class="setSortLogo('TNMT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MSA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['SMB']['MSA']}}
                                                <i @click="setSortTable('MSA')" :class="setSortLogo('MSA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TC']}}
                                                <i @click="setSortTable('TCD')" :class="setSortLogo('TCD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'NB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['NB']}}
                                                <i @click="setSortTable('NB')" :class="setSortLogo('NB')" class="sortlogo"></i>
                                            </template>
                                            <!--<span v-show="repoerIsCrypto" v-else-if="header == 'BCBA'">
        <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
        {{getLanguage['CYT']['BCBA']}}
        <i v-show="repoerIsCrypto" @click="setSortTable('TB')" :class="setSortLogo('BCBA')"></i>
    </span>
    <span v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'">
        <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
        {{getLanguage['CYT']['BCWLA']}}
        <i v-show="repoerIsCrypto" @click="setSortTable('WLA')" :class="setSortLogo('BCWLA')"></i>
    </span>-->
                                            <template v-else-if="header == 'TB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TB']}}
                                                <i @click="setSortTable('TB')" :class="setSortLogo('TB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['TA']}}
                                                <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'WLA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['WLA']}}
                                                <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AWR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['AWR']}}
                                                <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'NPL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['NPL']}}
                                                <i @click="setSortTable('NPL')" :class="setSortLogo('NPL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'HPL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['APL']}}(%)
                                                <i @click="setSortTable('HPL')" :class="setSortLogo('HPL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['PWL']}}
                                                <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'HWL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLBMRPT']['AWL']}}
                                                <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('TWLBMEM2', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['TWLBMEM2']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" id="searchExcludeSubAgent" />
                                        <label class="searchLabel ml-1" for="searchExcludeSubAgent">{{getLanguage["GL"]["ODA"]}}</label>
                                    </div>
                                </div>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            :disabled="searchExcludeSubAgent"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MT"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_userType"
                                            :placeholder="this.utilGetDDLanguage('MT.MT')"
                                            v-model="searchIsTester" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["WL"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_cwl"
                                            :placeholder="this.utilGetDDLanguage('MEM.WL')"
                                            v-model="chooseWinLoss">
                                </treeselect>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="true"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadSearchMemberCurrencyOptions"
                                            :options="ddCurrencyListFilter"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyFilter" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{ this.getLanguage['MT']['DAMT'] }} :</span>
                                <CInput size="sm"
                                        type="number"
                                        :value="searchMinDepositAmount"
                                        @change="v => searchMinDepositAmount = v"></CInput>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["MT"]["EDWP"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="arry_nonPromoDeposit"
                                            placeholder
                                            v-model="searchIsNonPromoDeposit" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton ref="search" v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['TWLBMEM2L']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th v-if="searchCurrency!=null" colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                        <td colspan="100%" v-if="arr_reportList.length == 0 && searchCurrency!=null && totalReport==null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr class="reportTotal2" v-if="totalReport!=null && searchCurrency!=null && arr_reportList.length > 0">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, 'totalreport')">
                                <template v-if="header == 'NO'">
                                </template>
                                <template v-else-if="header == 'AGT'" style="display:block;text-align:right">
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                </template>
                                <template v-else-if="header == 'U'">
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <span :style="changeNegativecolor(totalReport.CBL)">{{formatNumber(totalReport.CBL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    {{formatNumber(totalReport.TAND, 0)}}
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <span :style="changeNegativecolor(totalReport.TAD)">{{formatNumber(totalReport.TAD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <span :style="changeNegativecolor(totalReport.AD)">{{formatNumber(totalReport.AD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    {{formatNumber(totalReport.TANW, 0)}}
                                </template>
                                <template v-else-if="header == 'TAW'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TAW, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    {{formatNumber(totalReport.NP, 0)}}
                                </template>
                                <template v-else-if="header == 'TP'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TP, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'DLS'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.DLS, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AR'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.ARA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'A'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.AA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TNMT'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TNMTA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'MSA'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.PDA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TC'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TCD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    {{formatNumber(totalReport.NB, 0)}}
                                </template>
                                <!--<template v-show="repoerIsCrypto" v-else-if="header == 'BCBA'" :style="changeNegativecolor(totalReport.BCBA)">{{totalReport.BCBA}}</template>
            <template v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'" :style="changeNegativecolor(totalReport.BCWLA)">{{totalReport.BCWLA}}</template>-->
                                <template v-else-if="header == 'TB'">
                                    <span :style="changeNegativecolor(totalReport.TB)">{{formatNumber(totalReport.TB, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <span :style="changeNegativecolor(totalReport.TA)">{{formatNumber(totalReport.TA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <span :style="changeNegativecolor(totalReport.WLA)">{{formatNumber(totalReport.WLA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="totalReport.TA > 0" :class="MarginCal(totalReport.WLA,totalReport.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport.WLA,totalReport.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <span :style="changeNegativecolor(totalReport.NPL)">{{formatNumber(totalReport.NPL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <span :style="changeNegativecolor(totalReport.HPL)"> {{formatNumber(totalReport.HPL, 2)}} %</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="changeNegativecolor(totalReport.PWL)">{{formatNumber(totalReport.PWL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <span :style="changeNegativecolor(totalReport.AWL)">{{formatNumber(totalReport.AWL, 2, totalReport.CS)}}</span>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th v-if="searchCurrency!=null" colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}}</th>
                        </tr>
                        <td colspan="100%" v-if="arr_reportList.length == 0 && searchCurrency!=null && allTotalReport==null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr class="reportTotal2" v-if="allTotalReport!=null && searchCurrency!=null && arr_reportList.length > 0">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, 'totalreport')">
                                <template v-if="header == 'NO'">
                                </template>
                                <template v-if="header == 'AGT'">
                                </template>
                                <template v-if="header == 'PKVC'">
                                </template>
                                <template v-if="header == 'U'">
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <span :style="changeNegativecolor(allTotalReport.CBL)">{{formatNumber(allTotalReport.CBL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    {{formatNumber(allTotalReport.TAND, 0)}}
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <span :style="changeNegativecolor(allTotalReport.TAD)">{{formatNumber(allTotalReport.TAD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <span :style="changeNegativecolor(allTotalReport.AD)">{{formatNumber(allTotalReport.AD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    {{formatNumber(allTotalReport.TANW, 0)}}
                                </template>
                                <template v-else-if="header == 'TAW'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TAW, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    {{formatNumber(allTotalReport.NP, 0)}}
                                </template>
                                <template v-else-if="header == 'TP'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TP, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'DLS'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.DLS, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AR'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.ARA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'A'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.AA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TNMT'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TNMTA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'MSA'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.PDA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TC'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TCD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    {{formatNumber(allTotalReport.NB, 0)}}
                                </template>
                                <!--<template v-show="repoerIsCrypto" v-else-if="header == 'BCBA'" :style="changeNegativecolor(allTotalReport.BCBA)">{{allTotalReport.BCBA}}</template>
            <template v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'" :style="changeNegativecolor(allTotalReport.BCWLA)">{{allTotalReport.BCWLA}}</template>-->
                                <template v-else-if="header == 'TB'">
                                    <span :style="changeNegativecolor(allTotalReport.TB)">{{formatNumber(allTotalReport.TB, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <span :style="changeNegativecolor(allTotalReport.TA)">{{formatNumber(allTotalReport.TA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <span :style="changeNegativecolor(allTotalReport.WLA)">{{formatNumber(allTotalReport.WLA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="allTotalReport.TA > 0" :class="MarginCal(allTotalReport.WLA,allTotalReport.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport.WLA,allTotalReport.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <span :style="changeNegativecolor(allTotalReport.NPL)">{{formatNumber(allTotalReport.NPL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <span :style="changeNegativecolor(allTotalReport.HPL)"> {{formatNumber(allTotalReport.HPL, 2)}} %</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="changeNegativecolor(allTotalReport.PWL)">{{formatNumber(allTotalReport.PWL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <span :style="changeNegativecolor(allTotalReport.AWL)">{{formatNumber(allTotalReport.AWL, 2, allTotalReport.CS)}}</span>
                                </template>
                            </td>
                        </tr>
                        <draggable v-model="reportHeaders" tag="tr">
                            <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="header == 'NPL' ? 'background: #562c87 !important;' : ''">
                                <template v-if="header == 'NO'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage["GL"]["NO"]}}
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AG')" :class="setSortLogo('AG')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['GPS']['PKVC']}}
                                </template>
                                <template v-else-if="header == 'U'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['CKMMW']}}
                                    <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NND']}}
                                    <i @click="setSortTable('TAND')" :class="setSortLogo('TAND')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TND']}}
                                    <i @click="setSortTable('TAD')" :class="setSortLogo('TAD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AD']}}
                                    <i @click="setSortTable('AD')" :class="setSortLogo('AD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TANW']}}
                                    <i @click="setSortTable('TANW')" :class="setSortLogo('TANW')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TAW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TAW']}}
                                    <i @click="setSortTable('TAW')" :class="setSortLogo('TAW')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NP']}}
                                    <i @click="setSortTable('NP')" :class="setSortLogo('NP')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TP'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TP']}}
                                    <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'DLS'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['DLS']}}
                                    <i @click="setSortTable('DLS')" :class="setSortLogo('DLS')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AR'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AR']}}
                                    <i @click="setSortTable('ARA')" :class="setSortLogo('ARA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'A'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['A']}}
                                    <i @click="setSortTable('AA')" :class="setSortLogo('AA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TNMT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['TNMT']['TNMT']}}
                                    <i @click="setSortTable('TNMT')" :class="setSortLogo('TNMT')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'MSA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['SMB']['MSA']}}
                                    <i @click="setSortTable('MSA')" :class="setSortLogo('MSA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TC']}}
                                    <i @click="setSortTable('TCD')" :class="setSortLogo('TCD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NB']}}
                                    <i @click="setSortTable('NB')" :class="setSortLogo('NB')" class="sortlogo"></i>
                                </template>
                                <!--<span v-show="repoerIsCrypto" v-else-if="header == 'BCBA'">
                <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                {{getLanguage['CYT']['BCBA']}}
                <i v-show="repoerIsCrypto" @click="setSortTable('TB')" :class="setSortLogo('BCBA')"></i>
            </span>
            <span v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'">
                <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                {{getLanguage['CYT']['BCWLA']}}
                <i v-show="repoerIsCrypto" @click="setSortTable('WLA')" :class="setSortLogo('BCWLA')"></i>
            </span>-->
                                <template v-else-if="header == 'TB'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TB']}}
                                    <i @click="setSortTable('TB')" :class="setSortLogo('TB')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TA']}}
                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['WLA']}}
                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['BETRPT']['AWR']}}
                                    <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NPL']}}
                                    <i @click="setSortTable('NPL')" :class="setSortLogo('NPL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['APL']}}(%)
                                    <i @click="setSortTable('HPL')" :class="setSortLogo('HPL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['PWL']}}
                                    <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AWL']}}
                                    <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                </template>
                            </th>
                        </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th v-if="searchCurrency!=null" colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                        <td colspan="100%" v-if="arr_reportList.length == 0 && searchCurrency!=null && totalReport==null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr class="reportTotal2" v-if="totalReport!=null && searchCurrency!=null && arr_reportList.length > 0">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, 'totalreport')">
                                <template v-if="header == 'NO'">
                                </template>
                                <template v-else-if="header == 'AGT'" style="display:block;text-align:right">
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                </template>
                                <template v-else-if="header == 'U'">
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <span :style="changeNegativecolor(totalReport.CBL)">{{formatNumber(totalReport.CBL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    {{formatNumber(totalReport.TAND, 0)}}
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <span :style="changeNegativecolor(totalReport.TAD)">{{formatNumber(totalReport.TAD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <span :style="changeNegativecolor(totalReport.AD)">{{formatNumber(totalReport.AD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    {{formatNumber(totalReport.TANW, 0)}}
                                </template>
                                <template v-else-if="header == 'TAW'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TAW, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    {{formatNumber(totalReport.NP, 0)}}
                                </template>
                                <template v-else-if="header == 'TP'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TP, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'DLS'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.DLS, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AR'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.ARA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'A'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.AA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TNMT'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TNMTA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'MSA'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.PDA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TC'" style="color:red">
                                    <span style="color:red">{{formatNumber(totalReport.TCD, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    {{formatNumber(totalReport.NB, 0)}}
                                </template>
                                <!--<template v-show="repoerIsCrypto" v-else-if="header == 'BCBA'" :style="changeNegativecolor(totalReport.BCBA)">{{totalReport.BCBA}}</template>
            <template v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'" :style="changeNegativecolor(totalReport.BCWLA)">{{totalReport.BCWLA}}</template>-->
                                <template v-else-if="header == 'TB'">
                                    <span :style="changeNegativecolor(totalReport.TB)">{{formatNumber(totalReport.TB, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <span :style="changeNegativecolor(totalReport.TA)">{{formatNumber(totalReport.TA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <span :style="changeNegativecolor(totalReport.WLA)">{{formatNumber(totalReport.WLA, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="totalReport.TA > 0" :class="MarginCal(totalReport.WLA,totalReport.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(totalReport.WLA,totalReport.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <span :style="changeNegativecolor(totalReport.NPL)">{{formatNumber(totalReport.NPL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <span :style="changeNegativecolor(totalReport.HPL)"> {{formatNumber(totalReport.HPL, 2)}} %</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="changeNegativecolor(totalReport.PWL)">{{formatNumber(totalReport.PWL, 2, totalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <span :style="changeNegativecolor(totalReport.AWL)">{{formatNumber(totalReport.AWL, 2, totalReport.CS)}}</span>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th v-if="searchCurrency!=null" colspan="100%" style="z-index:1 !important">{{this.getLanguage['WLRPT']['AT']}}</th>
                        </tr>
                        <td colspan="100%" v-if="arr_reportList.length == 0 && searchCurrency!=null && allTotalReport==null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr class="reportTotal2" v-if="allTotalReport!=null && searchCurrency!=null && arr_reportList.length > 0">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, 'totalreport')">
                                <template v-if="header == 'NO'">
                                </template>
                                <template v-if="header == 'AGT'">
                                </template>
                                <template v-if="header == 'PKVC'">
                                </template>
                                <template v-if="header == 'U'">
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <span :style="changeNegativecolor(allTotalReport.CBL)">{{formatNumber(allTotalReport.CBL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    {{formatNumber(allTotalReport.TAND, 0)}}
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <span :style="changeNegativecolor(allTotalReport.TAD)">{{formatNumber(allTotalReport.TAD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <span :style="changeNegativecolor(allTotalReport.AD)">{{formatNumber(allTotalReport.AD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    {{formatNumber(allTotalReport.TANW, 0)}}
                                </template>
                                <template v-else-if="header == 'TAW'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TAW, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    {{formatNumber(allTotalReport.NP, 0)}}
                                </template>
                                <template v-else-if="header == 'TP'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TP, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'DLS'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.DLS, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AR'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.ARA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'A'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.AA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TNMT'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TNMTA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'MSA'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.PDA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TC'" style="color:red">
                                    <span style="color:red">{{formatNumber(allTotalReport.TCD, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    {{formatNumber(allTotalReport.NB, 0)}}
                                </template>
                                <!--<template v-show="repoerIsCrypto" v-else-if="header == 'BCBA'" :style="changeNegativecolor(allTotalReport.BCBA)">{{allTotalReport.BCBA}}</template>
            <template v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'" :style="changeNegativecolor(allTotalReport.BCWLA)">{{allTotalReport.BCWLA}}</template>-->
                                <template v-else-if="header == 'TB'">
                                    <span :style="changeNegativecolor(allTotalReport.TB)">{{formatNumber(allTotalReport.TB, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <span :style="changeNegativecolor(allTotalReport.TA)">{{formatNumber(allTotalReport.TA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <span :style="changeNegativecolor(allTotalReport.WLA)">{{formatNumber(allTotalReport.WLA, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="allTotalReport.TA > 0" :class="MarginCal(allTotalReport.WLA,allTotalReport.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(allTotalReport.WLA,allTotalReport.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <span :style="changeNegativecolor(allTotalReport.NPL)">{{formatNumber(allTotalReport.NPL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <span :style="changeNegativecolor(allTotalReport.HPL)"> {{formatNumber(allTotalReport.HPL, 2)}} %</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="changeNegativecolor(allTotalReport.PWL)">{{formatNumber(allTotalReport.PWL, 2, allTotalReport.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <span :style="changeNegativecolor(allTotalReport.AWL)">{{formatNumber(allTotalReport.AWL, 2, allTotalReport.CS)}}</span>
                                </template>
                            </td>
                        </tr>
                        <draggable v-model="reportHeaders" tag="tr">
                            <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)" :style="header == 'NPL' ? 'background: #562c87 !important;' : ''">
                                <template v-if="header == 'NO'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage["GL"]["NO"]}}
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AG')" :class="setSortLogo('AG')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['GPS']['PKVC']}}
                                </template>
                                <template v-else-if="header == 'U'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['CKMMW']}}
                                    <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NND']}}
                                    <i @click="setSortTable('TAND')" :class="setSortLogo('TAND')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TND']}}
                                    <i @click="setSortTable('TAD')" :class="setSortLogo('TAD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AD']}}
                                    <i @click="setSortTable('AD')" :class="setSortLogo('AD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TANW']}}
                                    <i @click="setSortTable('TANW')" :class="setSortLogo('TANW')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TAW'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TAW']}}
                                    <i @click="setSortTable('TAW')" :class="setSortLogo('TAW')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NP']}}
                                    <i @click="setSortTable('NP')" :class="setSortLogo('NP')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TP'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TP']}}
                                    <i @click="setSortTable('TP')" :class="setSortLogo('TP')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'DLS'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['DLS']}}
                                    <i @click="setSortTable('DLS')" :class="setSortLogo('DLS')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AR'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AR']}}
                                    <i @click="setSortTable('ARA')" :class="setSortLogo('ARA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'A'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['A']}}
                                    <i @click="setSortTable('AA')" :class="setSortLogo('AA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TNMT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['TNMT']['TNMT']}}
                                    <i @click="setSortTable('TNMT')" :class="setSortLogo('TNMT')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'MSA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['SMB']['MSA']}}
                                    <i @click="setSortTable('MSA')" :class="setSortLogo('MSA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TC']}}
                                    <i @click="setSortTable('TCD')" :class="setSortLogo('TCD')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NB']}}
                                    <i @click="setSortTable('NB')" :class="setSortLogo('NB')" class="sortlogo"></i>
                                </template>
                                <!--<span v-show="repoerIsCrypto" v-else-if="header == 'BCBA'">
                <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                {{getLanguage['CYT']['BCBA']}}
                <i v-show="repoerIsCrypto" @click="setSortTable('TB')" :class="setSortLogo('BCBA')"></i>
            </span>
            <span v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'">
                <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                {{getLanguage['CYT']['BCWLA']}}
                <i v-show="repoerIsCrypto" @click="setSortTable('WLA')" :class="setSortLogo('BCWLA')"></i>
            </span>-->
                                <template v-else-if="header == 'TB'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TB']}}
                                    <i @click="setSortTable('TB')" :class="setSortLogo('TB')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['TA']}}
                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['WLA']}}
                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['BETRPT']['AWR']}}
                                    <i @click="setSortTable('AWR')" :class="setSortLogo('AWR')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['NPL']}}
                                    <i @click="setSortTable('NPL')" :class="setSortLogo('NPL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['APL']}}(%)
                                    <i @click="setSortTable('HPL')" :class="setSortLogo('HPL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['PWL']}}
                                    <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['WLBMRPT']['AWL']}}
                                    <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')" class="sortlogo"></i>
                                </template>
                            </th>
                        </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_reportList" :class="data.MS == 1? 'blacklist-row': ''">
                            <!--<td v-for="header in reportHeaders" :key="header" :class="header == 'AGT' ? 'sticky-left':''">-->
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    {{ data.I!=-1?CountItem(index+1):"" }}
                                </template>
                                <template v-else-if="header == 'AGT'">
                                    <span class="grid-line">{{ data.AG }}</span>
                                    <Span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</Span>
                                    <span class="grid-line text-primary">{{ data.RU }}</span>
                                </template>
                                <template v-else-if="header == 'PKVC'">
                                    {{ data.PKVC }}
                                </template>
                                <!--<span v-if="header == 'U'" class='kema-eft' @click="CheckingMember(data.AGI,data.I)">
                <span class="grid-line" v-if="data.I!=1">
                    <div class="custom-tooltip">
                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                        <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                    </div>
                    <div class="float-right">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                        </svg>
                    </div>
                </span>
            </span>-->
                                <template v-else-if="header == 'U'">
                                    <router-link :to="{ path:getLinkUrl(), query:{ as: 't', u: data.U, i: data.I,sagi:searchAgent, agi:searchAgi, wlt:chooseWinLoss, cur:searchCurrency , ut: searchIsTester, df: parseDateToJsonString(sc_daterange.startDate), dt: parseDateToJsonString(sc_daterange.endDate) }}">
                                        <!--<i v-if="data.TW == 0" class="fa-solid fa-square-plus" style="cursor: pointer;color: rgb(201, 84, 90)"></i>-->
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(obj_member)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.MT)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.MT}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip mr-1" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                    </router-link>
                                </template>
                                <template v-else-if="header == 'CKMMW'">
                                    <span :style="changeNegativecolor(data.CBL)">{{formatNumber(data.CBL, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NND'">
                                    {{formatNumber(data.TAND, 0)}}
                                </template>
                                <template v-else-if="header == 'TND'">
                                    <span :style="changeNegativecolor(data.TAD)">{{formatNumber(data.TAD, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AD'">
                                    <span :style="changeNegativecolor(data.AD)">{{formatNumber(data.AD, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TANW'">
                                    {{formatNumber(data.TANW, 0)}}
                                </template>
                                <template v-else-if="header == 'TAW'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.TAW, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NP'">
                                    {{formatNumber(data.NP, 0)}}
                                </template>
                                <template v-else-if="header == 'TP'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.TP, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'DLS'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.DLS, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AR'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.ARA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'A'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.AA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TNMT'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.TNMTA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'MSA'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.PDA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TC'" style="color:red">
                                    <span style="color:red">{{formatNumber(data.TCD, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'NB'">
                                    {{formatNumber(data.NB, 0)}}
                                </template>
                                <!--<template v-show="repoerIsCrypto" v-else-if="header == 'BCBA'" :style="changeNegativecolor(data.BCBA)">{{data.BCBA}}</template>
            <template v-show="repoerIsCrypto" v-else-if="header == 'BCWLA'" :style="changeNegativecolor(data.BCWLA)">{{data.BCWLA}}</template>-->
                                <template v-else-if="header == 'TB'">
                                    <span :style="changeNegativecolor(data.TB)">{{formatNumber(data.TB, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <span :style="changeNegativecolor(data.TA)">{{formatNumber(data.TA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    <span :style="changeNegativecolor(data.WLA)">{{formatNumber(data.WLA, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'AWR'">
                                    <span v-if="data.TA > 0" :class="MarginCal(data.WLA,data.TA) < 0? 'negative-number': 'positive-number'">{{ formatNumber(MarginCal(data.WLA,data.TA), 2, "") }}%</span>
                                    <span class="" v-else>-</span>
                                </template>
                                <template v-else-if="header == 'NPL'">
                                    <span :style="changeNegativecolor(data.NPL)">{{formatNumber(data.NPL, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HPL'">
                                    <span :style="changeNegativecolor(data.HPL)"> {{formatNumber(data.HPL, 2)}} %</span>
                                </template>
                                <template v-else-if="header == 'PWL'">
                                    <span :style="changeNegativecolor(data.PWL)">{{formatNumber(data.PWL, 2, data.CS)}}</span>
                                </template>
                                <template v-else-if="header == 'HWL'">
                                    <span :style="changeNegativecolor(data.AWL)">{{formatNumber(data.AWL, 2, data.CS)}}</span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "TA", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_showDetails: false,
                bool_showSearchBar: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                // dropdown value
                ddAgentList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                dd_cwl: [
                    { id: '0', label: 'All' },
                    { id: '1', label: 'Win' },
                    { id: '2', label: 'Loss' },
                    { id: '3', label: 'Draw' },
                ],//win/Loss
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                ddCurrencyList: null,
                dd_userType: [],
                // search fields
                searchAgi: 0,
                searchAgent: null,
                searchUserId: null,
                chooseWinLoss: null,
                searchUsername: null,
                searchReferralUserId: null,
                searchReferralUsername: null,
                searchGameProviderId: null,
                searchCurrency: null,
                searchCurrencyFilter: null,
                searchRegisterSourceName:null,
                searchMinDepositAmount:null,
                searchIsNonPromoDeposit: null,
                arry_nonPromoDeposit: [],
                searchUserType: null,
                searchIsTester: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                arr_reportTotalList: [],
                reportType: null,
                skipPageUpdate: false,
                dd_memberKey: 0,
                dd_referralMemberKey: 0,
                sc_userid: 0,
                sc_username: null,
                sc_daterange: { startDate: null, endDate: null },
                sc_cur: null,
                sc_curf: null,
                sc_agi: null,
                sc_agent: null,
                constAccessType: constAccessType,
                needResetHeaders: false,
                defaultReportHeaders: ['NO', 'AGT','PKVC', 'U', 'CKMMW', 'NND', 'TND', 'AD', 'TANW', 'TAW', 'NP', 'TP', 'DLS', 'AR', 'A', 'TNMT', 'MSA', 'TC', 'NB', 'BCBA', 'BCWLA', 'TB', 'TA', 'WLA', 'AWR', 'NPL', 'HPL', 'PWL', 'HWL'],
                reportHeaders: [],
                totalReport: null,
                allTotalReport: null,
                bool_isFirstLoad: true,
                repoerIsCrypto: false,
                hideBrand: false,
                arry_vdp: [],
                searchVDP: null,
                rtSubBrand: 0,
                dd_subagentgroup: [],//subagent group option,
                ddDefaultSubBrand: [],
                searchSubAgent: null,
                ddCurrencyListFilter: null,
                obj_Post: {
                    SelectedBrands1: null
                },
                bool_isDDMV: false,
                searchExcludeSubAgent: false
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            getCWL() {
                this.dd_cwl = [
                    { id: '0', label: this.getLanguage['GL']['ALL2'] },
                    { id: '1', label: this.getLanguage['WLRPT']['RWIN'] },
                    { id: '2', label: this.getLanguage['WLRPT']['RL'] },
                    { id: '3', label: this.getLanguage['WLRPT']['RD'] },
                ]
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['GL']['YES'] }, { id: "0", label: this.getLanguage['GL']['NO'] }];
            },
            getNonPromoDeposit() {
                this.arry_nonPromoDeposit = [{ id: "1", label: this.getLanguage['GL']['YES'] }, { id: "0", label: this.getLanguage['GL']['NO'] }];
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}

                //this.searchAgi = 0;
                //if (value) {
                //    var agentList = value.split("-");
                //    this.searchAgi = agentList[agentList.length - 1];
                //}
                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
                this.searchSubAgent = null;
                this.ddCurrencyListFilter = null;
                this.searchCurrencyFilter = null;
            },
            getReportList(loadGrandTotal = true) {
                this.bool_fullLoading = true;
                var that = this;
                //var agentGId = null;

                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}
                sessionStorage.setItem('TWLBMEM2_FilterAGI', '');
                sessionStorage.setItem('TWLBMEM2_FilterAgent', '');
                sessionStorage.setItem('TWLBMEM2_FilterMI', '');
                sessionStorage.setItem('TWLBMEM2_FilterRI', '');
                sessionStorage.setItem('TWLBMEM2_FilterGPI', '');
                sessionStorage.setItem('TWLBMEM2_FilterCI', '');
                sessionStorage.setItem('TWLBMEM2_FilterCIF', '');
                sessionStorage.setItem('TWLBMEM2_FilterSTS_from', '');
                sessionStorage.setItem('TWLBMEM2_FilterSTS_to', '');
                sessionStorage.setItem('TWLBMEM2_FilterVDP', '');
                sessionStorage.setItem('TWLBMEM2_FilterITU', '');

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}

                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                    this.pre_searchAgi = this.searchAgi;
                    sessionStorage.setItem('TWLBMEM2_FilterAGI', this.searchAgi);
                    sessionStorage.setItem('TWLBMEM2_FilterAgent', this.searchAgent);
                }

                if (this.searchSubAgent) {
                    path += "&f.SAGI=" + this.searchSubAgent;
                    sessionStorage.setItem('TWLBMEM2_FilterSAGI', this.searchSubAgent);
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                    sessionStorage.setItem('TWLBMEM2_FilterMI', this.searchUserId);
                    sessionStorage.setItem('TWLBMEM2_FilterMName', this.searchUsername);
                }
                if (this.chooseWinLoss != null) {
                    path += "&f.CWL=" + this.chooseWinLoss;
                    sessionStorage.setItem('TWLBMEM2_FilterCWL', this.chooseWinLoss);
                } else {
                    path += "&f.CWL=0";
                    sessionStorage.setItem('TWLBMEM2_FilterCWL', 0);
                }

                if (this.searchIsTester) {
                    path += "&f.ITU=" + this.searchIsTester;
                    sessionStorage.setItem('TWLBMEM2_FilterITU', this.searchIsTester);
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                    sessionStorage.setItem('TWLBMEM2_FilterRI', this.searchReferralUserId);
                    sessionStorage.setItem('TWLBMEM2_FilterRName', this.searchReferralUsername);
                }

                if (this.searchGameProviderId) {
                    path += "&f.GPI=" + this.searchGameProviderId;
                    sessionStorage.setItem('TWLBMEM2_FilterGPI', this.searchGameProviderId);
                }
                if (this.searchCurrency) {
                    path += "&f.CCI=" + this.searchCurrency;
                    sessionStorage.setItem('TWLBMEM2_FilterCI', this.searchCurrency);
                }
                if (this.searchCurrencyFilter) {
                    path += "&f.CI=" + this.searchCurrencyFilter;
                    sessionStorage.setItem('TWLBMEM2_FilterCIF', this.searchCurrencyFilter);
                    
                }

                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        sessionStorage.setItem('TWLBMEM2_FilterSTS_from', this.parseDateToJsonString(this.searchCreatedTS.startDate));
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        sessionStorage.setItem('TWLBMEM2_FilterSTS_to', this.parseDateToJsonString(this.searchCreatedTS.endDate));
                    }
                }

                if (this.searchMinDepositAmount) {
                    path += "&f.MINDA=" + this.searchMinDepositAmount;
                }

                if (this.searchIsNonPromoDeposit) {
                    path += "&f.NONPD=" + this.searchIsNonPromoDeposit;
                    sessionStorage.setItem('TWLBMEM2_FilterIsNonPromoDeposit', this.searchIsNonPromoDeposit);
                }

                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                    sessionStorage.setItem('TWLBMEM2_FilterVDP', this.searchVDP);
                }

                if (!this.searchSubAgent) {
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.getDataApi(`/api/reports/winloss/totalbmem2?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.repoerIsCrypto = false;
                            that.temp_providerName = null;
                            that.sc_userid = that.searchUserId;
                            that.sc_username = that.searchUsername;
                            that.sc_daterange = that.searchCreatedTS;
                            that.sc_cur = that.searchCurrency;
                            that.sc_curf = that.searchCurrencyFilter;
                            that.sc_agi = that.searchAgi;
                            that.sc_agent = that.searchAgent;

                            that.int_TP = Math.max(d.Item1.D.TotalPages, 1);
                            that.int_Total = d.Item1.D.TotalItems;
                            that.arr_reportList = d.Item1.D.Items;
                            that.totalReport = d.Item2;
                            that.resizeTableHead();

                            for (var i = 0; i < d.Item1.D.Items.length; i++) {
                                if (d.Item1.D.Items[i].ICT)
                                    that.repoerIsCrypto = d.Item1.D.Items[i].ICT;
                            }
                        }
                    });
                if (loadGrandTotal) {
                    this.getDataApi(`/api/reports/winloss/alltotalbmem2?${path}`,
                        function (data) {
                            that.allTotalReport = data;
                            that.resizeTableHead();
                        });
                }
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            saveToExcel() {

                this.bool_fullLoading = false;
                var that = this;
                //var agentGId = null;

                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}

                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                    this.pre_searchAgi = this.searchAgi;
                }
                if (this.searchSubAgent) {
                    path += "&f.SAGI=" + this.searchSubAgent;
                }
                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }
                if (this.chooseWinLoss != null) {
                    path += "&f.CWL=" + this.chooseWinLoss;
                } else {
                    path += "&f.CWL=0";
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }

                if (this.searchGameProviderId) {
                    path += "&f.GPI=" + this.searchGameProviderId;
                }
                if (this.searchCurrency) {
                    path += "&f.CCI=" + this.searchCurrency;
                }
                if (this.searchCurrencyFilter) {
                    path += "&f.CI=" + this.searchCurrencyFilter;
                }

                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }

                if (this.searchMinDepositAmount) {
                    path += "&f.MINDA=" + this.searchMinDepositAmount;
                }
                if (this.searchIsNonPromoDeposit) {
                    path += "&f.NONPD=" + this.searchIsNonPromoDeposit;
                }
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }

                if (this.searchIsTester) {
                    path += "&f.ITU=" + this.searchIsTester;
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (!this.searchSubAgent) {
                    path += "&f.EXSAG=" + this.searchExcludeSubAgent;
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }


                window.open('/api/reports/winlossexcel/totalbmem2?' + path, '_blank');
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    //this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }
                else {
                    this.searchUsername = null;
                }
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    //this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                    this.obj_Post.SelectedBrands1 = this.searchAgi;

                    this.postDataApi(`/api/dd/mreferralbypost/${searchQuery}`, this.obj_Post,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList(false);
            },
            loadSearchMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgi) {
                    this.searchAgi = 0;
                }

               // this.getDataApi(`/api/dd/currency/${this.searchAgi}`,
                this.obj_Post.SelectedBrands1 = this.searchAgi;

                this.postDataApi(`/api/dd/curbyagilist/1`, this.obj_Post,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyListFilter = d.dropdownlist;
                            //========= set default convert currency to USD====
                            if (that.bool_isFirstLoad && !that.searchCurrencyFilter) {
                                for (var i = 0; i < that.ddCurrencyListFilter.length; i++) {
                                    if (that.ddCurrencyListFilter[i].label == 'USD') {
                                        that.searchCurrencyFilter = that.ddCurrencyListFilter[i].id;
                                        break;
                                    }                                    
                                }
                                that.bool_isFirstLoad = false;
                            }
                        }
                        else {
                            that.searchCurrencyFilter = null;
                            that.searchCurrencyFilter = null;
                        }

                        callback();
                    });
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            break;
                                        }
                                    }
                                }
                                //========= set default convert currency to USD====
                                else
                                {
                                    if (that.bool_isFirstLoad && !that.searchCurrency) {
                                        for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                            if (that.ddCurrencyList[i].label == 'USD') {
                                                that.searchCurrency = that.ddCurrencyList[i].id;
                                                break;
                                            }
                                        }
                                        
                                    }
                                }
                                that.bool_isFirstLoad = false;
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                            that.searchCurrency = null;
                        }

                        callback();
                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);

                }
            },
            changeNegativecolor(value) {
                if (value < 0) {
                    return {
                        color: 'red',
                        display: 'block'
                    }
                }
                else if (value > 0) {
                    return {
                        color: 'green',
                        display: 'block'
                    }
                }
                return { display: 'block' }
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            renderClassName(header, title) {
                if (header == 'U') {
                    return "kema-eft";
                } else if (header == 'CKMMW' || header == 'NND' || header == 'TND' || header == 'AD' || header == 'TANW' || header == 'TAW' || header == 'NP' || header == 'TP' || header == 'DLS' || header == 'AR' || header == 'A' || header == 'TC' || header == 'NB' || header == 'TB' || header == 'TA' || header == 'WLA' || header == 'AWR' || header == 'HPL' || header == 'PWL' || header == 'HWL') {
                    return "tableCtnRight";
                } else if (header == 'NPL' && title == 'totalreport') {
                    return "tableCtnRight";
                } else if (header == 'NPL' && title != 'totalreport') {
                    return "tableCtnRight winlossBg";
                }
            },
            resetColumn(headerName) {
                var that = this;
                if (!that.repoerIsCrypto) {
                    that.removeDefaultColumn('BCBA')
                    that.removeDefaultColumn('BCWLA')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(5) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }

                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.searchSubAgent = agi;
                            }
                        });
                }
                else {
                    this.searchSubAgent = null;
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    var agiSelectedValue = this.searchAgent[0];

                    var agentList = agiSelectedValue.split("-");
                    if (agentList.length > 0) {
                        parentAGI = agentList[1];
                    }
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                    
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getReportList();
                    });
            },
            getLinkUrl() {
                var downUrl = '/R/WINLV2';
                sessionStorage.setItem(downUrl, this.$route.path);
                return downUrl;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            MarginCal(winloss, turnover) {
                var formatWinloss = this.formatNumber(winloss);
                var formatTurnover = this.formatNumber(turnover);
                formatWinloss = Number(formatWinloss.toString().replaceAll(',', ''));
                formatTurnover = Number(formatTurnover.toString().replaceAll(',', ''));
                var result = (formatWinloss / formatTurnover) * -100;
                return result;
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        watch: {
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/TotalWinLossByMember2`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1) {
                                            if (!that.repoerIsCrypto && (that.defaultReportHeaders[i] == 'BCBA' || that.defaultReportHeaders[i] == 'BCWLA')) {
                                                continue;
                                            } else {
                                                that.reportHeaders.push(that.defaultReportHeaders[i]);
                                            }
                                        }
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (!that.repoerIsCrypto) {
                                    that.removeDefaultColumn('BCBA')
                                    that.removeDefaultColumn('BCWLA')
                                    that.removeColumn('BCBA')
                                    that.removeColumn('BCWLA')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/TotalWinLossByMember2/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            },
            getLanguage() {
                this.getReportList();
                this.getMemberTypeList();
                this.getVDP();
                this.getCWL();
                this.getNonPromoDeposit();
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = 'R.TWLBMEM2';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;
            if (this.isOUTMOB) {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            //========= when is outlet mobile set default convert currency to MYR====
                            for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                if (that.ddCurrencyList[i].label == 'MYR') {
                                    that.searchCurrency = that.ddCurrencyList[i].id;
                                    break;
                                }
                            }
                        }
                    });
            }

            if (this.$route.query.back && this.$route.query.back == 1) {
                var FilterAGI = sessionStorage.getItem('TWLBMEM2_FilterAGI');
                var FilterAgent = sessionStorage.getItem('TWLBMEM2_FilterAgent');
                if (FilterAGI && FilterAgent) {
                    this.searchAgi = FilterAGI;
                    this.searchAgent = FilterAgent.split(',');
                }

                var FilterSAGI = sessionStorage.getItem('TWLBMEM2_FilterSAGI');
                if (FilterSAGI) {
                    this.searchSubAgent = FilterSAGI;
                }

                var FilterGPI = sessionStorage.getItem('TWLBMEM2_FilterGPI');
                if (FilterGPI) {
                    this.searchGameProviderId = FilterGPI.split(',');
                    this.arr_displayGPI = this.searchGameProviderId.map(Number);
                }

                var FilterMI = sessionStorage.getItem('TWLBMEM2_FilterMI');
                var FilterMName = sessionStorage.getItem('TWLBMEM2_FilterMName');
                if (FilterMI && FilterMName) {
                    this.searchUserId = FilterMI;
                    this.searchUsername = FilterMName;
                    this.ddDefaultMemberList = [
                        { id: this.searchUserId, label: this.searchUsername }
                    ];
                }

                var FilterITU = sessionStorage.getItem('TWLBMEM2_FilterITU');
                if (FilterITU) {
                    this.searchIsTester = FilterITU;
                }

                var FilterCI = sessionStorage.getItem('TWLBMEM2_FilterCI');
                if (FilterCI) {
                    this.searchCurrency = FilterCI;
                }

                var FilterCIF = sessionStorage.getItem('TWLBMEM2_FilterCIF');
                if (FilterCIF) {
                    this.searchCurrencyFilter = FilterCIF;
                }

                var FilterSTS_from = sessionStorage.getItem('TWLBMEM2_FilterSTS_from');
                if (FilterSTS_from) {
                    this.searchCreatedTS.startDate = FilterSTS_from;
                }

                var FilterSTS_to = sessionStorage.getItem('TWLBMEM2_FilterSTS_to');
                if (FilterSTS_to) {
                    this.searchCreatedTS.endDate = FilterSTS_to;
                }

                var FilterVDP = sessionStorage.getItem('TWLBMEM2_FilterVDP');
                if (FilterVDP) {
                    this.searchVDP = FilterVDP;
                }

                var FilterWLT = sessionStorage.getItem('TWLBMEM2_FilterWLT');
                if (FilterWLT) {
                    this.chooseWinLoss = FilterWLT;
                }

                var FilterIsNonPromoDeposit = sessionStorage.getItem('TWLBMEM2_FilterIsNonPromoDeposit');
                if (FilterVDP) {
                    this.searchIsNonPromoDeposit = FilterIsNonPromoDeposit;
                }

            } else {

                if (this.$route.query.sagi && this.$route.query.sagi != 0) {
                    this.searchAgent = this.$route.query.sagi;
                    if (this.$route.query.agi && this.$route.query.agi != 0) {
                        this.searchAgi = this.$route.query.agi;
                    }
                }

                if (this.$route.query.ut) {
                    this.searchIsTester = this.$route.query.ut;
                }

                if (this.$route.query.wlt) {
                    this.chooseWinLoss = this.$route.query.wlt;
                }

                if (this.$route.query.cur) {
                    this.searchCurrency = this.$route.query.cur;
                }

                if (this.$route.query.df) {
                    this.searchCreatedTS.startDate = this.$route.query.df;
                }

                if (this.$route.query.dt) {
                    this.searchCreatedTS.endDate = this.$route.query.dt;
                }

                if (this.$route.query.as == 't') {
                    this.bool_showDetails = true;
                }
            }
            this.getMemberTypeList();
            this.getVDP();
            this.getCWL();
            this.getNonPromoDeposit();
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
            if (this.$route.path != this.$route.fullPath)
                this.getReportList();
            else {
                sessionStorage.setItem(this.$route.path, '');
            }            
        },
    }
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TotalWinLossByMember2.vue